<template>
  <div class="container">
    <titular />
    <ul class="list-inline">
      <li class="list-inline-item">
        <modal ref="modalCreacion" titulo="Afegir treballador" icono="fa-solid fa-plus" :loading="loading.creacion" @abrir="abrirModal('autofocusCreacion')" @cerrar="cerrarCreacion">
          <template v-slot:body>
            <form id="form-creacion" autocomplete="off" @submit.prevent="crear">
              <div class="form-group">
                <label for="nuevo-nom">Nom</label>
                <input ref="autofocusCreacion" type="text" class="form-control" id="nuevo-nom" v-model="nuevos.trabajador.nom" :disabled="loading.creacion" maxlength="255" required />
              </div>
              <div class="form-group">
                <label for="nuevo-cognoms">Cognoms</label>
                <input type="text" class="form-control" id="nuevo-cognoms" v-model="nuevos.trabajador.cognoms" :disabled="loading.creacion" maxlength="255" />
              </div>
              <div class="form-group">
                <label for="nuevo-perfil">Perfil</label>
                <select class="form-control" id="nuevo-perfil" v-model="nuevos.trabajador.perfil" :disabled="loading.creacion">
                  <option v-for="(perfil, index) in perfiles" :key="index">{{ perfil }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="nuevo-jornada">Jornada</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-jornada" v-model="nuevos.trabajador.jornada" :disabled="loading.creacion" min="0" max="100" required />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
              <div class="custom-control custom-switch mb-3">
                <input type="checkbox" class="custom-control-input" id="nuevo-te_pladedicacio" v-model="nuevos.trabajador.te_pladedicacio" :disabled="loading.creacion" />
                <label class="custom-control-label" for="nuevo-te_pladedicacio">Pla de dedicació</label>
              </div>
              <div class="form-group">
                <label for="nuevo-email_calendar">Google Calendar</label>
                <input type="email" class="form-control" id="nuevo-email_calendar" v-model="nuevos.trabajador.email_calendar" :disabled="loading.creacion" maxlength="320" />
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-creacion" :disabled="loading.creacion">
              <i-submit icono="fa-plus" :loading="loading.creacion" />Confirmar
            </button>
          </template>
        </modal>
      </li>
    </ul>
    <vue-bootstrap4-table ref="tabla" :rows="rows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap treballador</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="refresh-button-text">
        <i class="fa-solid fa-rotate" title="Actualitzar dades" @click="getData" v-tooltip></i>
      </template>
      <template slot="reset-button-text">
        <i class="fa-solid fa-eraser" title="Reiniciar vista" v-tooltip></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="acciones" slot-scope="props">
        <div class="btn-group btn-group-sm" role="group" aria-label="Accions">
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-editar-${props.row.id}`" title="Editar treballador" v-tooltip><i class="fa-solid fa-pen-to-square"></i></button>
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-eliminar-${props.row.id}`" title="Eliminar treballador" v-tooltip><i class="fa-solid fa-trash-can"></i></button>
        </div>
        <div class="text-left">
          <modal :ref="`modalEdicion${props.row.id}`" titulo="Editar treballador" icono="fa-solid fa-pen-to-square" btnClass="btn-secondary" :hayLanzador="false" :modalId="`editar-${props.row.id}`" :loading="loading.edicion" @abrir="abrirModal(`autofocusEdicion${props.row.id}`)" @cerrar="cerrarEdicion">
            <template v-slot:body>
              <form :id="`form-edicion${props.row.id}`" autocomplete="off" @submit.prevent="editar(props.row.id)">
                <div class="custom-control custom-switch mb-3">
                  <input type="checkbox" class="custom-control-input" :id="`actiu${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).es_actiu" :disabled="loading.edicion" />
                  <label class="custom-control-label" :for="`actiu${props.row.id}`">Actiu</label>
                </div>
                <div class="form-group">
                  <label :for="`nom${props.row.id}`">Nom</label>
                  <input :ref="`autofocusEdicion${props.row.id}`" type="text" class="form-control" :id="`nom${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).nom" :disabled="loading.edicion" maxlength="255" required />
                </div>
                <div class="form-group">
                  <label :for="`cognoms${props.row.id}`">Cognoms</label>
                  <input type="text" class="form-control" :id="`cognoms${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).cognoms" :disabled="loading.edicion" maxlength="255" />
                </div>
                <div class="form-group">
                  <label :for="`perfil${props.row.id}`">Perfil</label>
                  <select class="form-control" :id="`perfil${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).perfil" :disabled="loading.edicion">
                    <option v-for="(perfil, index) in perfiles" :key="index">{{ perfil }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label :for="`jornada${props.row.id}`">Jornada</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`jornada${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).jornada" :disabled="loading.edicion" min="0" max="100" required />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
                <div class="custom-control custom-switch mb-3">
                  <input type="checkbox" class="custom-control-input" :id="`te_pladedicacio${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).te_pladedicacio" :disabled="loading.edicion" />
                  <label class="custom-control-label" :for="`te_pladedicacio${props.row.id}`">Pla de dedicació</label>
                </div>
                <div class="form-group">
                  <label :for="`email_calendar${props.row.id}`">Google Calendar</label>
                  <input type="email" class="form-control" :id="`email_calendar${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).email_calendar" :disabled="loading.edicion" maxlength="320" />
                </div>
              </form>
            </template>
            <template v-slot:footer>
              <button type="submit" class="btn btn-primary" :disabled="loading.edicion" :form="`form-edicion${props.row.id}`">
                <i-submit icono="fa-pen-to-square" :loading="loading.edicion" />Confirmar
              </button>
            </template>
          </modal>
          <modal :ref="`modalEliminacion${props.row.id}`" titulo="Eliminar treballador" icono="fa-solid fa-trash-can" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${props.row.id}`" :loading="loading.eliminacion" @abrir="abrirModal(`autofocusEliminacion${props.row.id}`)" @cerrar="cerrarEliminacion">
            <template v-slot:body>
              <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
              Vols eliminar a <b>{{ props.row.nombre_completo }}</b>?
            </template>
            <template v-slot:footer>
              <button :ref="`autofocusEliminacion${props.row.id}`" type="submit" class="btn btn-danger" :disabled="loading.eliminacion" @click="eliminar(props.row.id)">
                <i-submit icono="fa-trash-can" :loading="loading.eliminacion" />Confirmar
              </button>
            </template>
          </modal>
        </div>
      </template>
      <template slot="es_actiu" slot-scope="props">
        <i v-show="props.cell_value" class="fa-solid fa-circle-check"></i>
      </template>
      <template slot="perfil" slot-scope="props">
        <span class="badge badge-primary">{{ props.cell_value }}</span>
      </template>
      <template slot="jornada" slot-scope="props">
        {{ formatearDecimales(props.cell_value) }}%
      </template>
    </vue-bootstrap4-table>
  </div>
</template>


<script>
export default {
  name: "Treballadors",
  inject: ["formatearDecimales", "exportarTabla", "exportarBolcat", "actionsExportar"],
  data() {
    return {
      loading: {
        creacion: false,
        edicion: false,
        eliminacion: false,
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "#",
          name: "id",
          filter: {
            type: "simple",
            placeholder: "Filtra ID",
          },
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc",
          row_text_alignment: "text-left",
        },
        {
          label: "Actiu",
          name: "es_actiu",
          filter: {
            type: "select",
            mode: "single",
            closeDropdownOnSelection: true,
            placeholder: "Filtra estat",
            options: [
              {
                name: "Actiu",
                value: 1,
              },
              {
                name: "Inactiu",
                value: 0,
              },
            ],
          },
          sort: false,
          row_text_alignment: "text-center",
          slot_name: "es_actiu",
        },
        {
          label: "Nom complet",
          name: "nombre_completo",
          filter: {
            type: "simple",
            placeholder: "Filtra nom",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Perfil",
          name: "perfil",
          filter: {
            type: "simple",
            placeholder: "Filtra perfil",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Jornada",
          name: "jornada",
          filter: {
            type: "simple",
            placeholder: "Filtra jornada",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Google Calendar",
          name: "email_calendar",
          filter: {
            type: "simple",
            placeholder: "Filtra e-mail",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Accions",
          name: "acciones",
          row_text_alignment: "text-center",
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Tots els treballadors",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
      nuevos: {
        trabajador: {
          nom: null,
          cognoms: null,
          perfil: null,
          jornada: 100,
          email_calendar: null,
          te_pladedicacio: false,
        },
      },
      perfiles: [],
    };
  },
  methods: {
    getData: function () {
      this.$http.get("api/treballadors").then((response) => {
        this.rows = response.data;
      });

      this.$http.get("api/treballadors?valores=perfil").then((response) => {
        this.perfiles = response.data;
      });
    },
    getRowId: function (id, rows) {
      return rows.find((element) => {
        return element.id == id;
      });
    },
    crear: function () {
      this.loading.creacion = true;

      this.$http
        .post("api/treballadors", this.nuevos.trabajador)
        .then((response) => {
          this.loading.creacion = false;

          this.$nextTick(function () {
            if (response.status == 201) {
              this.rows.push(response.data);

              this.$refs.modalCreacion.cerrar();

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Treballador afegit correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.creacion = false;
        });
    },
    editar: function (id) {
      this.loading.edicion = true;

      this.$http
        .patch(`api/treballadors/${id}`, this.getRowId(id, this.rowsBuffer))
        .then((response) => {
          this.loading.edicion = false;

          this.$nextTick(function () {
            if (response.status == 200) {
              this.$refs[`modalEdicion${id}`].cerrar();
              this.getRowId(id, this.rowsBuffer).nombre_completo = response.data.nombre_completo;

              this.rows = structuredClone(this.rowsBuffer);

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Treballador editat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.edicion = false;
        });
    },
    eliminar: function (id) {
      this.loading.eliminacion = true;

      this.$http
        .delete(`api/treballadors/${id}`)
        .then((response) => {
          this.loading.eliminacion = false;

          this.$nextTick(function () {
            this.$refs[`modalEliminacion${id}`].cerrar();

            if (response.status == 200) {
              const found = this.rows.find((element) => element.id == id);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Treballador eliminat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.eliminacion = false;
        });
    },
    abrirModal: function (autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
    cerrarCreacion: function () {
      this.nuevos.trabajador.nom = null;
      this.nuevos.trabajador.cognoms = null;
      this.nuevos.trabajador.perfil = null;
      this.nuevos.trabajador.jornada = 100;
      this.nuevos.trabajador.email_calendar = null;
      this.nuevos.trabajador.te_pladedicacio = false;
    },
    cerrarEdicion: function () {
      this.rowsBuffer = structuredClone(this.rows);
    },
    cerrarEliminacion: function () {
      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
    exportarTablaPrevio() {
      this.exportarTabla(this.$route.name, this.$refs.tabla);
    },
    exportarBolcatPrevio() {
      this.exportarBolcat(this.$route.name, this.$refs.tabla);
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    rows: function (value) {
      this.rowsBuffer = structuredClone(value);
    },
  },
};
</script>